<div class="button-groups">
    <button (click)="isLoading=!isLoading" nz-button nztype="default">Toggle Loading</button>
</div>
<div echarts [options]="options" [loading]="isLoading" theme="macarons"></div>